import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";

const rewardfulKey = process.env.REACT_APP_REWARDFUL;
if (rewardfulKey && typeof document !== "undefined") {
  (function (w: any, r: string) {
    w._rwq = r;
    w[r] = w[r] || function() {
      (w[r].q = w[r].q || []).push(arguments);
    };
  })(window as any, "rewardful");

  const s = document.createElement("script");
  s.async = true;
  s.src = "https://r.wdfl.co/rw.js";
  s.setAttribute("data-rewardful", rewardfulKey);
  document.head.appendChild(s);
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
